export const rules = {
	// Card titles
	"rules.card.rules.title": "Règles",
	"rules.card.goals.title": "Buts",
	"rules.card.cleanSheets.title": "Feuilles blanches",
	"rules.card.cards.title": "Cartons",
	"rules.card.misc.title": "Divers",
	"rules.card.captains.title": "Capitaines et Vice-Capitaines",
	"rules.card.eligibility.title": "Éligibilité et Prix",
	"rules.card.weeklyPrizes.title": "Structure des Prix Hebdomadaires",
	"rules.card.finalRules.title": "Distribution des Prix et Départage",

	// Main rules content
	"rules.intro":
		'Tous les termes en majuscules utilisés dans ces règles (les <strong>"Règles"</strong>) porteront la définition qui leur est attribuée dans les conditions générales (les <strong>"Conditions générales"</strong>).',

	"rules.rule1":
		"Les participants peuvent sélectionner leur meilleure équipe chaque semaine/tour (selon le cas), pertinente à la compétition à laquelle le jeu Betway Scores BW Fantasy Football se rapporte, par exemple la Premier League anglaise, etc. La compétition Betway Scores BW Fantasy Football commencera le 11 mars 2025 et se terminera à la fin de la saison de football 2025/2026.",

	"rules.rule2": "Chaque semaine/tour correspond aux tours de cette ligue.",

	"rules.rule3":
		"Les participants peuvent sélectionner un maximum de deux (2) joueurs par équipe de ligue participante à inclure dans leur équipe Betway Scores BW Fantasy Football chaque semaine/tour.",

	"rules.rule4":
		"Les participants doivent activement sélectionner leur équipe chaque semaine/tour, avec l'option d'apporter des modifications ou de choisir de garder la même équipe en place pour la semaine/tour suivant.",

	"rules.rule5":
		"Les points sont attribués comme suit pour chacune des actions suivantes effectuées par les joueurs que le participant sélectionne dans son équipe Betway Scores BW Fantasy Football chaque semaine/tour :",

	// Goals points
	"rules.goals.forwardGoals": "Buts d'attaquant",
	"rules.goals.forwardGoalsValue": "4",
	"rules.goals.midfielderGoals": "Buts de milieu de terrain",
	"rules.goals.midfielderGoalsValue": "5",
	"rules.goals.defenderGoals": "Buts de défenseur",
	"rules.goals.defenderGoalsValue": "10",
	"rules.goals.goalkeeperGoals": "Buts de gardien",
	"rules.goals.goalkeeperGoalsValue": "20",
	"rules.goals.penaltyGoals": "Buts sur penalty",
	"rules.goals.penaltyGoalsValue": "3",
	"rules.goals.ownGoals": "Buts contre son camp",
	"rules.goals.ownGoalsValue": "-5",
	"rules.goals.concededGoals": "Buts encaissés",
	"rules.goals.concededGoalsValue": "-1",

	// Clean sheets points
	"rules.cleanSheets.goalkeeperCleanSheet": "Feuille blanche du gardien",
	"rules.cleanSheets.goalkeeperCleanSheetValue": "5",
	"rules.cleanSheets.defenderCleanSheet": "Feuille blanche du défenseur",
	"rules.cleanSheets.defenderCleanSheetValue": "5",
	"rules.cleanSheets.midfielderCleanSheet": "Feuille blanche du milieu de terrain",
	"rules.cleanSheets.midfielderCleanSheetValue": "1",

	// Cards points
	"rules.cards.yellowCard": "Cartons jaunes",
	"rules.cards.yellowCardValue": "-2",
	"rules.cards.redCard": "Cartons rouges",
	"rules.cards.redCardValue": "-5",

	// Misc points
	"rules.misc.assists": "Passes décisives",
	"rules.misc.assistsValue": "4",
	"rules.misc.shotsOnTarget": "Tirs cadrés",
	"rules.misc.shotsOnTargetValue": "1",
	"rules.misc.tackles": "Tacles",
	"rules.misc.tacklesValue": "2",
	"rules.misc.saves": "Arrêts",
	"rules.misc.savesValue": "1",
	"rules.misc.minutesOver60": "Minutes jouées égales ou supérieures à 60",
	"rules.misc.minutesOver60Value": "2",
	"rules.misc.minutesUnder60": "Minutes jouées inférieures à 60",
	"rules.misc.minutesUnder60Value": "1",
	"rules.misc.penaltyWon": "Penalty obtenu",
	"rules.misc.penaltyWonValue": "3",
	"rules.misc.penaltiesConceded": "Penalty concédé",
	"rules.misc.penaltiesConcededValue": "-3",
	"rules.misc.penaltyMissed": "Penalty raté",
	"rules.misc.penaltyMissedValue": "-3",
	"rules.misc.offsides": "Hors-jeu",
	"rules.misc.offsidesValue": "-1",
	"rules.misc.foulsCommitted": "Fautes commises",
	"rules.misc.foulsCommittedValue": "-1",

	// Captain rules
	"rules.rule6":
		'Les participants peuvent attribuer un <strong>"Capitaine"</strong> à leur équipe qui recevra 3x points. Le Capitaine peut être changé chaque semaine/tour. Que le Capitaine soit changé pour la semaine/tour suivant ou maintenu en place pour la semaine/tour suivant, doit être activement sélectionné chaque semaine/tour par le Participant.',

	"rules.rule7":
		'Les participants peuvent attribuer un <strong>"Vice-Capitaine"</strong> à leur équipe qui recevra 2x points. Le Vice-Capitaine peut être changé chaque semaine/tour. Que le Vice-Capitaine soit changé pour la semaine/tour suivant ou maintenu en place pour la semaine/tour suivant, doit être activement sélectionné chaque semaine par le Participant.',

	// Eligibility and prizes
	"rules.rule8":
		"Tous les utilisateurs connectés de Betway Scores et/ou BW Scores sont éligibles pour jouer à BW Fantasy Football, cependant seuls les participants avec un compte Betway vérifié, au moment où les prix doivent être attribués, sont éligibles pour gagner des prix. Les changements dans les résultats des tours selon le point 2. ci-dessus (affectant les points sous le 5. ci-dessus) qui se produisent après l'attribution des prix (par exemple, annulation des résultats de match) ne seront pas considérés rétrospectivement.",

	"rules.rule9":
		"Le participant qualifié et éligible qui termine la saison en première place et possède un compte de paris Betway sera le gagnant du Grand Prix de la saison et gagnera un voyage pour deux (2) personnes pour voir Arsenal jouer à Londres, incluant les vols (si nécessaire), l'hébergement (si nécessaire) et £500 d'argent de poche.",

	"rules.rule10":
		"Si le gagnant du Grand Prix de la saison ne peut pas voyager en raison de ne pas avoir un passeport valide et/ou un visa et/ou toute autre limitation, il recevra un prix de €5 000 de solde en espèces, ou l'équivalent approximatif en monnaie locale à la date de commencement de la compétition (soit £4 500, R100 000 ou GH₵ 60 000), dans son compte Betway à la fin de la compétition.",

	"rules.rule11":
		"Le gagnant du Grand Prix de la saison peut choisir de ne pas prendre l'expérience et plutôt accepter un prix de €5 000 de solde en espèces, ou l'équivalent approximatif en monnaie locale à la date de commencement de la compétition (soit £4 500, R100 000 ou GH₵ 60 000), dans son compte Betway.",

	"rules.rule12":
		"Les prix hebdomadaires seront attribués aux 10 meilleurs performeurs chaque semaine/tour qui ont un compte de paris Betway valide. Si un des 10 meilleurs performeurs n'a pas de compte de paris Betway, il ne recevra pas de prix hebdomadaire.",

	"rules.rule13": "Les places hebdomadaires 1 à 10 gagneront les montants suivants de solde en espèces, selon la région, dans leur compte Betway :",

	// Weekly prize table headers
	"rules.weeklyPrizes.position": "Position Par Tour",
	"rules.weeklyPrizes.eur": "Gains de Solde en Espèces (EUR)",
	"rules.weeklyPrizes.gbp": "Gains de Solde en Espèces (GBP)",
	"rules.weeklyPrizes.zar": "Gains de Solde en Espèces (ZAR)",
	"rules.weeklyPrizes.ghs": "Gains de Solde en Espèces (GHS)",

	// Weekly prize values
	"rules.weeklyPrizes.1st.eur": "€150",
	"rules.weeklyPrizes.1st.gbp": "£150",
	"rules.weeklyPrizes.1st.zar": "R3000",
	"rules.weeklyPrizes.1st.ghs": "GH₵ 2000",

	"rules.weeklyPrizes.2nd.eur": "€100",
	"rules.weeklyPrizes.2nd.gbp": "£100",
	"rules.weeklyPrizes.2nd.zar": "R2000",
	"rules.weeklyPrizes.2nd.ghs": "GH₵ 1250",

	"rules.weeklyPrizes.3rd.eur": "€75",
	"rules.weeklyPrizes.3rd.gbp": "£75",
	"rules.weeklyPrizes.3rd.zar": "R1500",
	"rules.weeklyPrizes.3rd.ghs": "GH₵ 1000",

	"rules.weeklyPrizes.4th.eur": "€50",
	"rules.weeklyPrizes.4th.gbp": "£50",
	"rules.weeklyPrizes.4th.zar": "R1000",
	"rules.weeklyPrizes.4th.ghs": "GH₵ 600",

	"rules.weeklyPrizes.5th.eur": "€40",
	"rules.weeklyPrizes.5th.gbp": "£40",
	"rules.weeklyPrizes.5th.zar": "R800",
	"rules.weeklyPrizes.5th.ghs": "GH₵ 500",

	"rules.weeklyPrizes.6th.eur": "€30",
	"rules.weeklyPrizes.6th.gbp": "£30",
	"rules.weeklyPrizes.6th.zar": "R600",
	"rules.weeklyPrizes.6th.ghs": "GH₵ 400",

	"rules.weeklyPrizes.7th.eur": "€20",
	"rules.weeklyPrizes.7th.gbp": "£20",
	"rules.weeklyPrizes.7th.zar": "R400",
	"rules.weeklyPrizes.7th.ghs": "GH₵ 250",

	"rules.weeklyPrizes.8th.eur": "€15",
	"rules.weeklyPrizes.8th.gbp": "£15",
	"rules.weeklyPrizes.8th.zar": "R300",
	"rules.weeklyPrizes.8th.ghs": "GH₵ 200",

	"rules.weeklyPrizes.9th.eur": "€10",
	"rules.weeklyPrizes.9th.gbp": "£10",
	"rules.weeklyPrizes.9th.zar": "R200",
	"rules.weeklyPrizes.9th.ghs": "GH₵ 100",

	"rules.weeklyPrizes.10th.eur": "€10",
	"rules.weeklyPrizes.10th.gbp": "£10",
	"rules.weeklyPrizes.10th.zar": "R200",
	"rules.weeklyPrizes.10th.ghs": "GH₵ 100",

	// Final rules
	"rules.rule14":
		"Les prix hebdomadaires seront attribués dans les 7 (sept) jours suivant la finalisation des résultats de cette semaine et le Grand Prix sera attribué dans les 7 (sept) jours suivant la conclusion de la compétition Betway Scores BW Fantasy Football.",

	"rules.rule15":
		"En cas d'égalité pour les prix hebdomadaires, le solde en espèces pour cette position (et les positions pertinentes en dessous qui sont impactées par l'égalité) sera partagé équitablement entre les participants à égalité.",

	"rules.rule16":
		"En cas d'égalité pour le Grand Prix, un mécanisme de randomisation sera utilisé pour sélectionner seulement un des participants à égalité comme gagnant du Grand Prix.",

	"rules.temporary_notice":
		"Veuillez noter que les gagnants de prix pendant la période du 19 décembre 2025 au 2 janvier 2026 recevront leurs prix dans les 7 (sept) jours à partir du 6 janvier 2026",
};
